export type FieldType =
  | 'kisa_metin'
  | 'uzun_metin'
  | 'tarih'
  | 'telefon'
  | 'eposta'
  | 'sayi'
  | 'secim'
  | 'checkbox'
  | 'imza'

export type FieldSource = 'otomatik' | 'personel'

export type TemplateMethod = 'sistem' | 'docx' | 'pdf'

export type SurumStatus = 'taslak' | 'yayinda' | 'arsiv'

export type MappingStatus = 'eslesti' | 'manuel' | 'tanimsiz'

export type DocField = {
  id: string
  key: string
  label: string
  type: FieldType
  source: FieldSource
  /** Otomatik alanlar için değişken anahtarı, örn. personel.ad_soyad */
  variable?: string
  required: boolean
  placeholder?: string
  helpText?: string
  validation?: string
  errorMessage?: string
  options?: string[]
  sectionId: string
  pageId: string
}

export type DocSection = {
  id: string
  title: string
  pageId: string
  order: number
}

export type DocPage = {
  id: string
  title: string
  order: number
}

export type FieldColumns = 1 | 2 | 3

export const FIELD_COLUMNS: FieldColumns[] = [1, 2, 3]

export type DocBlock =
  | { id: string; kind: 'heading'; text: string; level: 1 | 2 }
  | { id: string; kind: 'richtext'; html: string; fontFamily?: string; fontSize?: number }
  | { id: string; kind: 'field'; fieldId: string; columns?: FieldColumns }
  | { id: string; kind: 'divider' }
  | { id: string; kind: 'signature'; fieldId: string; columns?: FieldColumns }
  | { id: string; kind: 'table'; rows: string[][]; headerTone?: TableTone }

export type TableTone = 'primary' | 'navy' | 'sky' | 'orange' | 'dark' | 'light'

export type UploadedTemplateFile = {
  name: string
  sizeBytes: number
  mime: string
  kind: 'docx' | 'pdf'
  /** Oturum içi object URL — yenilemede kaybolur; localStorage’a yazılmaz */
  previewUrl?: string
}

export type VariableMapping = {
  templateVar: string
  mappedFieldKey: string | null
  status: MappingStatus
  note?: string
}

export type BelgeSablon = {
  id: string
  ad: string
  kategori: string
  aciklama: string
  zorunlu: boolean
  departmanIds: string[]
  pozisyonlar: string[]
  kontrolSorumlusu: string
  method: TemplateMethod
  status: SurumStatus
  currentVersion: number
  createdAt: string
  updatedAt: string
  createdBy: string
}

export type SablonSurum = {
  id: string
  sablonId: string
  version: number
  status: SurumStatus
  changeReason: string
  method: TemplateMethod
  pages: DocPage[]
  sections: DocSection[]
  fields: DocField[]
  blocksBySection: Record<string, DocBlock[]>
  uploadedFile?: UploadedTemplateFile
  /** DOCX için gerçek çıkarım yoksa demo değişken listesi */
  demoVariables?: string[]
  variableMappings?: VariableMapping[]
  createdAt: string
  publishedAt?: string
  editorFont: string
  editorFontSize: number
  lineHeight: number
  margins: { top: number; right: number; bottom: number; left: number }
  letterhead?: Partial<Letterhead>
}

export type Letterhead = { companyName: string; legalName: string; department: string }

export type PersonelBelgeKayit = {
  id: string
  personelId: string
  sablonId: string
  surumId: string
  status: 'bekliyor' | 'onaylandi' | 'reddedildi'
  approvedAt?: string
}

export type BelgeInfoForm = {
  ad: string
  kategori: string
  aciklama: string
  zorunlu: boolean
  departmanIds: string[]
  pozisyonlar: string[]
  kontrolSorumlusu: string
}

export type PublishMode = 'future_only' | 'all_matching' | 'selected_employees'

export type WizardStep = 1 | 2 | 3 | 4

export type DiffKind = 'added' | 'changed' | 'removed' | 'unchanged'

export type FieldDiff = {
  key: string
  label: string
  kind: DiffKind
}

export type VariableDef = {
  key: string
  label: string
  group: string
  sample?: string
}

export const DOC_FONTS = [
  { value: 'Arial, Helvetica, sans-serif', label: 'Arial' },
  { value: 'Calibri, Candara, Segoe UI, sans-serif', label: 'Calibri' },
  { value: '"Times New Roman", Times, serif', label: 'Times New Roman' },
  { value: 'Georgia, serif', label: 'Georgia' },
  { value: 'Verdana, Geneva, sans-serif', label: 'Verdana' },
  { value: '"Inter Variable", Inter, ui-sans-serif, sans-serif', label: 'Inter' },
] as const

export const FIELD_TYPES: FieldType[] = [
  'kisa_metin',
  'uzun_metin',
  'tarih',
  'telefon',
  'eposta',
  'sayi',
  'secim',
  'checkbox',
  'imza',
]

/** Belge kategorisi = BE personel belge türü kodu (`/documents/types?domain=employee`). */
export type BelgeKategori = string
